import { useMemo } from "react";
import { LoadingView } from "../../../components";
import { useGetObjectsChildren } from "../../../hooks/useGetObjectsChildren";
import { ObjectBooleanTimeline } from "../../../features/Charts/ObjectBooleanTimeline";
import { getTimeRangeFromTimespan } from "../../../utils/timeUtils";
import { themedUseStyletron } from "../../../theme/customTheme";
import { ParagraphMedium } from "baseui/typography";
import { FormattedMessage } from "react-intl";
import { schema as schemaMultistate } from '../../Devices/MultiState/types'
import MultiStateInsightsPanel from '../../Devices/MultiState/InsightsPanel'
import { ISP_Room } from "./types";


const InsightsPanel = (props: ISP_Room) => {
    const [css, theme] = themedUseStyletron()
    const { children, isLoading, isSuccess, refetch } = useGetObjectsChildren(props.resourceGroupId, props.id)
    const mstate = useMemo(() => children?.find((v: any) => v.schema === schemaMultistate), [children]);

    const timeRange = getTimeRangeFromTimespan(7 * 24 * 60);

    return (
        <LoadingView isLoading={isLoading} isSucess={isSuccess}>
            <ObjectBooleanTimeline label={<FormattedMessage id="SP_Room.IsHeating" defaultMessage="is heating" />} currentValue={props.isHeating} onColor={theme.colors.negative400} showStatistics offColor={theme.colors.backgroundTertiary} start={timeRange.start} end={timeRange.end} objectId={props.id} resourceGroupId={props.resourceGroupId} propertyName={'isHeating'}></ObjectBooleanTimeline>
            <ObjectBooleanTimeline label={<FormattedMessage id="SP_Room.IsCooling" defaultMessage="is cooling" />} currentValue={props.isCooling} onColor={theme.colors.accent300} showStatistics offColor={theme.colors.backgroundTertiary} start={timeRange.start} end={timeRange.end} objectId={props.id} resourceGroupId={props.resourceGroupId} propertyName={'isCooling'}></ObjectBooleanTimeline>
            {mstate &&
                <div>
                    <ParagraphMedium><FormattedMessage id="P_AirHandling.Plantswitch" defaultMessage="Plantswitch" /></ParagraphMedium>
                    <MultiStateInsightsPanel {...mstate}></MultiStateInsightsPanel>
                </div>}

        </LoadingView>
    )
}

export default InsightsPanel
